import React, { useState, useEffect } from 'react';
import { TextField, Button } from '@mui/material';
import DialogModal from '../../components/DialogModal';
import { GradeValidationErrors, validateGrade } from './utils/validategrade';
import { AddGradeProps } from './types/GradeScaleType';

const GradeEntryDialog: React.FC<AddGradeProps> = ({
  open,
  onClose,
  existingKey,
  gradeScale,
  setGradeScale
}) => {
  const isNew = existingKey === '';
  const existing = !isNew
    ? gradeScale.gradeScaling[existingKey]
    : { min: '', max: '' };

  const [gradeName, setGradeName] = useState(existingKey || '');
  const [min, setMin] = useState(existing.min);
  const [max, setMax] = useState(existing.max);
  const [errors, setErrors] = useState<GradeValidationErrors>({});

  useEffect(() => {
    if (!isNew) {
      setGradeName(existingKey);
      setMin(existing.min);
      setMax(existing.max);
    }
  }, [existingKey, existing.min, existing.max, isNew]);

  const handleSave = () => {
    const validationErrors = validateGrade(
      gradeName,
      min,
      max,
      gradeScale,
      isNew
    );
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;
    const copy = { ...gradeScale };
    if (!isNew && existingKey !== gradeName) {
      delete copy.gradeScaling[existingKey];
    }

    copy.gradeScaling[gradeName] = { min, max };
    setGradeScale(copy);
    onClose();
  };

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title={isNew ? 'Add Grade' : 'Edit Grade'}
      actions={
        <>
          <Button onClick={onClose} color='primary'>
            Cancel
          </Button>
          <Button variant='contained' onClick={handleSave}>
            Save
          </Button>
        </>
      }
    >
      <TextField
        margin='dense'
        label='Grade Name'
        fullWidth
        value={gradeName}
        onChange={(e) => setGradeName(e.target.value)}
        error={!!errors.gradeName}
        helperText={errors.gradeName}
      />
      <TextField
        margin='dense'
        label='Min Marks'
        fullWidth
        type='number'
        value={min}
        onChange={(e) => setMin(e.target.value)}
        error={!!errors.min}
        helperText={errors.min}
      />
      <TextField
        margin='dense'
        label='Max Marks'
        fullWidth
        type='number'
        value={max}
        onChange={(e) => setMax(e.target.value)}
        error={!!errors.max}
        helperText={errors.max}
      />
    </DialogModal>
  );
};

export default GradeEntryDialog;
